module.exports = __webpack_public_path__ + "static/media/2x5B.d7e47d38.svg";